import {
  TRANSACTION_REFUND_SUCCESS,
  TRANSACTION_REFUND_FAILED,
  RESET_TRANSACTION_REFUND,
  LOADING_TRANSACTION_REFUND,
  NETWORK_ERROR_TRANSACTION_REFUND,
} from "../types";

const initialState = {
  isLoading: false,
  failed: false,
  success: false,
  data: {},
  networkError: "",
  invalidRequest: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_TRANSACTION_REFUND: {
      return {
        ...state,
        isLoading: true,
        failed: false,
        success: false,
        invalidRequest: false,
        data: {},
      };
    }
    case TRANSACTION_REFUND_FAILED: {
      return {
        ...state,
        isLoading: false,
        failed: true,
        success: false,
        invalidRequest: false,
        data: action.payload,
      };
    }
    case TRANSACTION_REFUND_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: true,
        invalidRequest: false,
        data: action.payload,
      };
    }
    case NETWORK_ERROR_TRANSACTION_REFUND: {
      return {
        ...state,
        isLoading: false,
        failed: true,
        success: false,
        invalidRequest: false,
        networkError: "Something went wrong. Check internet connection",
        data: {},
      };
    }
    case RESET_TRANSACTION_REFUND: {
      return (state = initialState);
    }

    default:
      return state;
  }
};
